import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {  Cookies } from 'react-cookie';
import ChangeBodycarDiscntThirdparty from './ChangeBodycarDiscntThirdparty';
import ChangeBodycarDiscnt from './ChangeBodycarDiscnt';
import ChangeBodycarDiscntLife from './ChangeBodycarDiscntLife';
import ChangeBodycarDiscntAccbank from './ChangeBodycarDiscntAccbank';
import ChangeBodycarDiscntAnother from './ChangeBodycarDiscntAnother';
import ChangeBodycarDiscntPriority from './ChangeBodycarDiscntPriority';
import ChangeBodyCarUsefore from './ChangeBodyCarUsefore';
import ChangeBodyCarTime from './ChangeBodyCarTime';
import ChangeBodycarCoverage from './ChangeBodycarCoverage';
import ChangePriceBodyCar from './ChangePriceBodyCar';



const styles = theme => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }
  , paper: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(1),
        width: theme.spacing(20),
      },
    },


});

class ChangeBodyCar extends Component {
  cookies=new Cookies();
  constructor(props) {
      super(props);
    this.state = {
  value:9,
}}

componentDidMount() {

}
handleChange= (event,newValue) => {
  this.setState({ value:newValue });
}
    render() {
      const { classes } = this.props;
      const { value } = this.state;

        return (
          <div style={{dir:'ltr',direction: 'ltr'}}>
               <AppBar style={{dir:'ltr'}} position="sticky"color="primary" >

                   <Tabs
                     style={{height:'60px',textAlign:'center'}}
                     value={value}
                     onChange={this.handleChange}
                     indicatorColor="secondary"
                     textColor={'#000000'}
                     variant="scrollable"
                     scrollButtons="auto"
                     aria-label="scrollable auto tabs example"
                   >
                     <Tab label=" تخفیف ثالث بیمه نامه "  />
                     <Tab label="تخفیف بیمه بدنه"  />
                     <Tab label="تخفیف دارندگان بیمه عمر "  />
                     <Tab label="تخفیف حساب بلند مدت "  />
                     <Tab label="تخفیف های متفرقه"  />
                     <Tab label="عدد برای اولویت تخفیف ها "  />
                     <Tab label="مورد استفاده"  />
                     <Tab label="مدت زمان بیمه نامه "  />
                     <Tab label="پوشش اضافی بیمه نامه "  />
                     <Tab label="قیمت بیمه نامه "  />
                     </Tabs>


                 </AppBar>
                 {(value==0)?<ChangeBodycarDiscntThirdparty  props={this.props}/>:null}
                 {(value==1)?<ChangeBodycarDiscnt  props={this.props}/>:null}
                 {(value==2)?<ChangeBodycarDiscntLife  props={this.props}/>:null}
                 {(value==3)?<ChangeBodycarDiscntAccbank  props={this.props}/>:null}
                 {(value==4)?<ChangeBodycarDiscntAnother  props={this.props}/>:null}
                 {(value==5)?<ChangeBodycarDiscntPriority  props={this.props}/>:null}
                 {(value==6)?<ChangeBodyCarUsefore  props={this.props}/>:null}
                 {(value==7)?<ChangeBodyCarTime  props={this.props}/>:null}
                 {(value==8)?<ChangeBodycarCoverage  props={this.props}/>:null}
                 {(value==9)?<ChangePriceBodyCar  props={this.props}/>:null}

               </div>
        );
    }
}

export default  withStyles(styles)(ChangeBodyCar);
